import { Link } from "react-router-dom";
import FaqList from "@/components/feature/FaqList";
import SectionTitle from "@/components/base/SectionTitle";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const homeFaqs = faqs.slice(0, 6);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-[72px]">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionTitle
              eyebrow="FAQ"
              title="关于网暴黑料，最常被问到的几个问题"
              description="如果你对本站的立场、内容边界或维权路径有疑问，这里大概能找到答案。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-secondary-500 text-background-50 hover:bg-secondary-600"
            >
              查看完整问答
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqList items={homeFaqs} />
          </div>
        </div>
      </div>
    </section>
  );
}